<template>
  <div>
    <el-form-item label="父组件">
      <el-select v-model="value.parent" placeholder="请选择父组件" size="small" clearable>
        <el-option v-for="item in formItems" :key="item.id" :label="item.title" :value="item.id">
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="提示文字">
      <el-input size="small" v-model="value.placeholder" placeholder="请设置提示语" />
    </el-form-item>
  </div>
</template>

<script>
import { getItem } from '@/api/ops/conService';
export default {
  name: "ConServiceItemInputConfig",
  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 添加获取表单列表的属性
    formList: {
      type: Array,
      default: () => []
    },
  },
  data() {
    return {
    };
  },
  computed: {
    formItems(){
      return this.$store.state.design.formItems
    },
  },
  created() {
    if (this.$route.name == 'design') {
      // getItem(null, "1").then(res => {
      //   for (let i = 0; i < this.$store.state.design.formItems.length; i++) {
      //     if (this.$store.state.design.formItems[i].name === 'ConServiceItemInput') {
      //       this.$store.state.design.formItems[i].option = res
      //     }
      //   }
      // });
    }
  },
  methods: {
   
  }
};
</script>

